import Menu from './rule_coding.vue';

export default Menu;
